import PainfulMemoriesFlow from "@/components/Exercises/PainfulMemories/PainfulMemoriesFlow";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import MediaPlayer from "@/components/ui/media-player";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import painfulMemoAudio from "@/assets/audios/painful-memories.m4a";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/painful-memories/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "A Safe for Painful Memories - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "painfulMemories.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isPausedAudio, setIsPausedAudio] = useState(false);

  const startExercise = () => {
    setIsPausedAudio(true);
    setShowOverlay(true);
  };

  const closeOverlay = () => {
    setShowOverlay(false);
    setIsPausedAudio(false);
  };
  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="common.startExercise" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="painfulMemories.intro" />
      </p>
      <MediaPlayer
        src={painfulMemoAudio}
        segment={{ start: 0, end: 45 }}
        isPaused={isPausedAudio}
      />
      <PainfulMemoriesFlow
        isShow={showOverlay}
        onComplete={closeOverlay}
        onExit={closeOverlay}
      />
    </ExerciseLayout>
  );
}
